import {
  MUST_CONTAIN_FILTER,
  MUST_MATCH_ALL_FILTER,
  MUST_MATCH_ANY_FILTER,
  MUST_MATCH_NONE_FILTER,
  MUST_NOT_CONTAIN_FILTER,
} from "./filter-matchers";
import { z } from "zod";

export const MustMatchAnyMatchNoneSchema = z.enum([MUST_MATCH_ANY_FILTER, MUST_MATCH_NONE_FILTER]);

export const CheckboxFilterCheckedSchema = z.boolean();

export const CheckboxFilterTypeSchema = z.literal("checkbox");

export const MustMatchAllOrMatchNoneSchema = z.enum([MUST_MATCH_ALL_FILTER, MUST_MATCH_NONE_FILTER]);

export const MustContainNotContainSchema = z.enum([MUST_CONTAIN_FILTER, MUST_NOT_CONTAIN_FILTER]);

export const NumberRangeTypeFilterSchema = z.literal("number-range");

export const TwoNumberRangeTypeFilterSchema = z.array(z.number().nullable()).min(2).max(2);

export const OptionalDateRangeSchema = z
  .string()
  .nullable()
  .array()
  .min(2)
  .max(2)
  .describe("An array of two date strings (ISO format) or nulls for open-ended ranges");
